import React, { useEffect, useState } from 'react';
import { Timeline, Tag, Spin } from 'antd';
import { auditTrailApi, EntityKey } from '../../services/api/auditTrailApi';

export interface AuditTrailTimelineProps {
  entityType: EntityKey;
  entityId: number;
}

interface AuditEvent {
  id: number;
  event: string;
  actor_type: string;
  payload_json: string;
  created_at: string;
}

const ACTOR_COLOR: Record<string, string> = {
  staff: 'blue', customer: 'green', system: 'default', agent: 'purple',
};

export const AuditTrailTimeline: React.FC<AuditTrailTimelineProps> = ({ entityType, entityId }) => {
  const [events, setEvents] = useState<AuditEvent[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    auditTrailApi.list(entityType, entityId)
      .then(setEvents)
      .finally(() => setLoading(false));
  }, [entityType, entityId]);

  if (loading) return <Spin />;
  if (events.length === 0) return <div style={{ color: '#999' }}>No events yet.</div>;

  return (
    <Timeline
      items={events.map((e) => {
        let payload: any = {};
        try { payload = JSON.parse(e.payload_json || '{}'); } catch { /* ignore */ }
        return {
          color: ACTOR_COLOR[e.actor_type] ?? 'default',
          children: (
            <div>
              <Tag>{e.event}</Tag>
              <span style={{ color: '#666', marginLeft: 8 }}>
                {new Date(e.created_at).toLocaleString()}
              </span>
              {payload && Object.keys(payload).length > 0 && (
                <div style={{ fontSize: 12, color: '#999' }}>
                  {Object.entries(payload).map(([k, v]) => `${k}: ${String(v)}`).join(', ')}
                </div>
              )}
            </div>
          ),
        };
      })}
    />
  );
};

export default AuditTrailTimeline;
